module.exports = __webpack_public_path__ + "static/media/harley-davidson-XnhmpwEbv5I-unsplash.79f33e02.jpg";